import { use, useMemo } from "react";
import { TableViewContext } from "../../../../scripts/context/accountingTable/tableViewContext";

export const useFormConfig = () => {
    const { product } = use(TableViewContext);
    return useMemo(() => product.getConfig(), [product]);
};
